import _ from '@lodash';
import * as yup from 'yup';
import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import { useForm, FormProvider, Controller } from 'react-hook-form';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import EntriesListComponent from 'app/admin/model/component/EntriesListComponent';

import PiMeasurementReaderService from 'app/admin/piMeasurementReader/service/PiMeasurementReaderService';

const config = {
    'ANN': {
        method: 'annModelEditControl/addModelEntries',
        types: [{ name: 'Model', fieldName: 'model', accept: '.keras' }, { name: 'xScaler', fieldName: 'xScaler', accept: '.pkl' }, { name: 'yScaler', fieldName: 'yScaler', accept: '.pkl' }],
    },
    'HYSYS': {
        method: 'hysysModelEditControl/addModelEntry',
        types: [{ name: 'Hsc', fieldName: 'hscFile', accept: '.hsc' }],
    },
    'PETROSIM': {
        method: 'petrosimModelEditControl/addModelEntry',
        types: [{ name: 'Hsc', fieldName: 'hscFile', accept: '.hsc' }],
    },
    'SPREADSHEET': {
        method: 'spreadSheetModelEditControl/addModelEntry',
        types: [{ name: 'Worksheet', fieldName: 'xlsFile', accept: '.xls,.xlsx' }],
    }
}

export function EntriesDialog(props) {
    const history = useHistory();
    const { t } = useTranslation(['common']);
    const dispatch = useDispatch();
    const title = props.item && props.item.name ? `Entries - ${props.item.name}` : 'Entries';

    const getDefaultValues = () => {
        let defaultValues = {};
        return defaultValues;
    };

    const handleCancel = () => {
        props.onCancel();
    };

    return (
        <Dialog open fullWidth>

            <DialogTitle disableTypography className='border-b'>
                {title}
            </DialogTitle>

            <DialogContent className='p-20'>

                <EntriesListComponent id={props.item.id} method={config[props.item.type].method} types={config[props.item.type].types} />

            </DialogContent>

            <DialogActions className='justify-between border-t p-20'>

                <Button onClick={() => { handleCancel(); }}>
                    {t('CANCEL')}
                </Button>

            </DialogActions>

        </Dialog >
    );
}
export default EntriesDialog;
